import { RouteConfig } from 'vue-router';
// const PAGE_TITLE = '“光盘有奖 咖啡留香” 珍惜食物活动';
const PAGE_TITLE = '上游新闻帮帮志愿服务队';
const baseUrl = '20210121GPYJ';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'sharePage',
      name: `${baseUrl}-share`,
      component: () => import('./pages/Share.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'recruit',
      name: `${baseUrl}-recruit`,
      component: () => import('./pages/Invite.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'act-home',
      name: `${baseUrl}-act-home`,
      component: () => import('./pages/ActHome.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 2,
      },
    },
    {
      path: 'act-detail',
      name: `${baseUrl}-act-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
    },

    {
      path: 'answer',
      name: `${baseUrl}-answer`,
      component: () => import('./pages/Answer.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
    },
    {
      path: 'answerDetail',
      name: `${baseUrl}-answerDetail`,
      component: () => import('./pages/AnswerDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
    },
    {
      path: 'result',
      name: `${baseUrl}-result`,
      component: () => import('./pages/Result.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
    },
    {
      path: 'videoNews',
      name: `${baseUrl}-videoNews`,
      component: () => import('./pages/VideoNews.vue'),
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
    },
    {
      path: 'user-center',
      name: `${baseUrl}-user-center`,
      component: () => import('./pages/UserCenter.vue'),
      redirect: `/${baseUrl}/user-center/user-upload`,
      meta: {
        title: PAGE_TITLE,
        ranK: 3,
      },
      children: [
        {
          path: `/${baseUrl}/user-center/user-info`,
          name: `${baseUrl}-user-info`,
          component: () => import('./components/User.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: `/${baseUrl}/user-center/user-upload`,
          name: `${baseUrl}-user-upload`,
          component: () => import('./components/Upload.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
      ],
    },
  ],
};

export default route;
